<template>
<v-content style="background-color:#ECEFF1;">
    <v-container fluid>
        <v-row dense>
            <v-col cols="6" offset-cols="3" class="mb-3 mt-3">
                <v-card class="pt-1 pb-1" flat color="blue-grey lighten-5" height=40>
                  <v-col>
                  </v-col>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense justify="center">
            <v-col cols="12" sm="6" md="3" v-if="tokenValid">
                <v-card tile>
                  <v-tabs dark :grow="true" slider-color="#429a86" background-color="#354d5b" class="font-weight-medium" v-model="model">
                    <v-tab href="#tab-1" class="subtitle-1 text-none">
                      {{$t('reset.title')}}
                    </v-tab>
                    <v-tab-item :value="'tab-1'">
                      <v-card flat>
                        <v-card-text>
                          <v-form @submit.prevent="validateBeforeSubmit" ref="resetUserForm" @keyup.enter="validateBeforeSubmit">
                            <v-container fluid>
                              <v-row no-gutters>
                                <v-col>
                                    <v-card  class="py-2" color="#455a64" dark flat>
                                      <p  class="activation-info-label pa-0 ma-0">{{user.login}}</p>
                                    </v-card>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col>
                                  <v-text-field type="password" v-model="user.password" required
                                      :label="$t('administration.password')" color="#429a86"
                                      :error-messages="passwordErrors"
                                      @input="$v.user.password.$touch()"
                                      @blur="$v.user.password.$touch()">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col>
                                  <v-text-field type="password" v-model="user.newPassword" required
                                      :label="$t('administration.confirmPassword')" color="#429a86"
                                      :error-messages="newPasswordErrors"
                                      @input="$v.user.newPassword.$touch()"
                                      @blur="$v.user.newPassword.$touch()">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row no-gutters class="mt-4">
                                <v-col>
                                  <v-btn color="#429a86" :class="{'disable-events': loading}"
                                    :loading="loading" dark tile type="submit" class="text-none" block>
                                    {{$t('administration.apply')}}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</v-content>
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import Vuelidate from 'vuelidate'
import { validationMixin } from '@/mixins/validation'
import { required } from 'vuelidate/lib/validators'

Vue.use(Vuelidate)
export default {
  mixins: [validationMixin],
  name: 'reset',
  data () {
    return {
      model: this.value,
      loading: false,
      token: '',
      user: {
        login: ''
      },
      tokenValid: false
    }
  },
  created () {
    this.logConsole('Reset request received')
    this.token = this.$route.query.token
    const activationToken = { activationToken: this.token }

    this.$http.post(Vue.$apiConfig.validateResetTokenPost, activationToken)
      .then(response => {
        this.logConsole(response)
        this.tokenValid = true
        this.user = response.body.payload
      }, error => {
        this.logConsole(error)
        this.tokenValid = false
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('apiStatusCodes.' + error.data.status.code),
          errors: []
        })
      })
  },
  computed: {
    passwordErrors () {
      return !this.$v.user.password.$dirty ? [] : this.getUserValidationErrorsByName('password')
    },
    newPasswordErrors () {
      return !this.$v.user.newPassword.$dirty ? [] : this.getUserValidationErrorsByName('newPassword')
    }
  },
  methods: {
    getUserValidationErrorsByName (name) {
      return this.getValidationErrors('user').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      const validationErrors = this.getValidationErrors('user')
      if (validationErrors && validationErrors.length > 0) {
        return
      }

      this.resetUser()
    },
    resetUser () {
      this.logConsole('Resetting user')
      if (this.user.password === this.user.newPassword) {
        this.loading = true
        this.$http.post(Vue.$apiConfig.resetSystemUserPost + '?token=' + this.token, this.user)
          .then(response => {
            this.logConsole(response)
            this.loading = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('reset.success'),
              errors: []
            })
            this.$router.push('/login')
          }, error => {
            this.logConsole(error)
            this.loading = false
            this.formatErrorResponse(error)
          })
      } else {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('administration.confirmPasswordFail'),
          errors: []
        })
      }
    }
  },
  validations: {
    user: {
      password: {
        required
      },
      newPassword: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .narrow-container {
    width: 800px;
  }

  .activation-info-label {
    font-weight: 600;
    font-size: 15px;
    text-align: center;
  }
</style>
